<template>
  <HelpCenterDropdown
    :open="open"
    @close="close"
  >
    <template #toggle="{ toggleBinds }">
      <button
        class="help-center-mobile-nav__toggle"
        v-bind="toggleBinds"
        @click="toggle"
      >
        <p class="help-center-mobile-nav__label">
          {{ selectedTab.title }}
        </p>
        <HelpCenterIcon
          :name="menuIcon"
          size-units="5"
          class="help-center-mobile-nav__icon"
        />
      </button>
    </template>

    <template #dialog="{ dialogBinds, backdropBinds }">
      <dialog
        class="help-center-mobile-nav__dialog"
        v-bind="dialogBinds"
        tabindex="-1"
      >
        <div
          class="help-center-mobile-nav__backdrop"
          v-bind="backdropBinds"
        />
        <HelpCenterCategoryTree
          :type="type"
          :categories="categories"
          :selected-category="selectedCategory"
          class="help-center-mobile-nav__menu"
          @navigate="close"
        />
      </dialog>
    </template>
  </HelpCenterDropdown>
</template>

<script setup>
import { ref, computed } from 'vue'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'
import HelpCenterDropdown from 'help-center/components/HelpCenterDropdown'
import HelpCenterCategoryTree from 'help-center/components/HelpCenterCategoryTree'

defineProps({
  type: {
    type: String,
    required: true
  },
  categories: {
    type: Array,
    required: true
  },
  selectedTab: Object,
  selectedCategory: Object
})

const open = ref(false)

const menuIcon = computed(() => {
  if (open.value) {
    return 'chevronUp'
  } else {
    return 'chevronDown'
  }
})

function close() {
  open.value = false
}

function toggle() {
  open.value = !open.value
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-mobile-nav {
  &__toggle {
    @include help-center-accent-link($offset: -4px);
    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    height: $helpCenterMobileNavHeight;
    padding: $helpCenterMobileVerPadding $helpCenterMobileHorPadding;
    border-radius: 0px;
    border-bottom: 1px solid var(--help-center-border);
    background-color: white;
  }

  &__label {
    @include help-center-font(12);
    color: var(--help-center-text);
    font-weight: var(--help-center-bold);
    text-transform: uppercase;
  }

  &__icon {
    color: var(--help-center-muted);
  }

  &__dialog {
    @include help-center-dropdown;
    @include help-center-scroll-trap-outer;
    height: calc(100vh - #{$helpCenterMobileNavHeight} - #{$helpCenterMobileHeroHeight});
  }

  &__backdrop {
    @include help-center-backdrop;
    @include help-center-scroll-trap-inner;
  }

  &__menu {
    isolation: isolate;
    border-bottom: 1px solid var(--help-center-border);
    background-color: white;

    @include help-center-thin-scrollbar;
    padding: $helpCenterMobileVerPadding $helpCenterMobileHorPadding;
    max-height: 100%;
  }
}
</style>
